import { scrollTo } from '../helper-function/scrollTo';

export function initCardTestimonials() {
    const grid = document.querySelector('[data-masonry-grid]');
    if (!grid) return;
    const showMoreButton = document.querySelector('[data-btn-testimonials]');
    const btnText = showMoreButton.querySelector('[data-btn-text-new]');
    const btnImg = document.querySelector('[data-arrow]');
    let isShowAllCards = false;
    const activeClass = '--is-open';
    const rotateClass = '--rotate';

    // INITS
    resizeAllGridItems();

    // LISTENERS
    window.addEventListener('resize', resizeAllGridItems);
    showMoreButton.addEventListener('click', handleOnClick, false);

    //HANDLER
    function handleOnClick() {
        grid.classList.contains(activeClass) ? closeGrid(grid) : openGrid(grid);
    }

    // FUNCTIONS
    function openGrid(grid) {
        btnImg.classList.add(rotateClass);
        const newText = btnText.dataset.btnTextNew;
        btnText.textContent = newText;
        grid.classList.add(activeClass);
    }

    function closeGrid() {
        btnImg.classList.remove(rotateClass);
        const originalText = btnText.dataset.btnTextOriginal;
        btnText.textContent = originalText;
        grid.classList.remove(activeClass);

        window.scrollTo({
            top: grid.offsetTop - 70,
            behavior: 'smooth',
        });
    }

    function resizeAllGridItems() {
        const allItems = grid.querySelectorAll('[data-masonry-grid-card]');

        if (window.innerWidth < 600 && isShowAllCards) {
            [...allItems].forEach((item) => {
                item.style.display = 'flex';
            });
            return;
        }

        [...allItems].forEach((item) => {
            resizeGridItem(item);
        });
    }

    function resizeGridItem(item) {
        const innerItem = item.querySelector('[data-masonry-grid-card-inner]');
        const innerWidth = window.innerWidth > 680;
        const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        const rowSpan = Math.ceil((innerItem.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        let dataSet;

        if (item.dataset.articleName) dataSet = item.dataset.articleName;

        if (innerWidth && dataSet !== undefined) {
            item.style.gridRowEnd = 'span ' + (rowSpan + 1);
        } else {
            item.style.gridRowEnd = 'span ' + rowSpan;
        }

        if (isShowAllCards) {
            setTimeout(() => {
                item.style.display = 'flex';
            }, 0);
        }
    }
}
